import { Link } from 'react-router';
import './SiteChrome.css';
import { Logo } from '../Logo/Logo.tsx';
import { JEFF } from '../../config/jeff.ts';

interface HeaderProps {
  muted: boolean;
  onToggleMute: () => void;
}

/**
 * Wordmark, and nothing else.
 *
 * There was a nav here. On a site whose entire surface is one button, a nav
 * bar is furniture pretending to be structure — it implied somewhere else
 * worth going, and there wasn't.
 */
export function SiteHeader({ muted, onToggleMute }: HeaderProps) {
  return (
    <header className="chrome">
      <Link to="/" className="chrome__brand" aria-label={`${JEFF.appName} home`}>
        <Logo size="sm" />
      </Link>

      {JEFF.enableAudio && (
        <button
          type="button"
          className="chrome__mute"
          onClick={onToggleMute}
          aria-pressed={!muted}
          title={muted ? 'Unmute' : 'Mute'}
        >
          <span aria-hidden="true">{muted ? '🔇' : '🔈'}</span>
          <span className="visually-hidden">{muted ? 'Unmute audio' : 'Mute audio'}</span>
        </button>
      )}
    </header>
  );
}

/**
 * One line: the disclaimer, which is the only thing here that has to exist.
 *
 * A version string and a "no tracking" boast are things the author cares about,
 * not the reader. `/record` is still served, it just has no link — it is the
 * owner's own dashboard, not a destination.
 */
export function SiteFooter() {
  return (
    <footer className="chrome-foot">
      <p className="chrome-foot__disclaimer">{JEFF.disclaimer}</p>
    </footer>
  );
}
